import { array, boolean, intersect, literal, partial, string, struct, union } from 'io-ts/Decoder';

import { Point } from '../../../ui/geometry';
import { HexColor } from '../../../ui/HexColor';

// Decoder for marker shapes - matches constants.wholeHouse.rendering.MARKER_SHAPES
const MarkerShape = union(
	literal('circle'),
	literal('square'),
	literal('gps'),
	literal('heart'),
	literal('star'),
	literal('hexagon'),
	literal('triangle'),
	literal('diamond'),
	literal('shield'),
	literal('bookmark'),
	literal('bell'),
	literal('pentagon')
);

export const Marker = intersect(
	struct({
		id: string,
		name: string,
		type: literal('marker'),
		shape: MarkerShape,
		points: array(Point),
	})
)(
	partial({
		color: HexColor,
		isImported: boolean,
	})
);
